export const FAQS = [
  {
    title: "What deployment options does Zadara Cloud support?",
    content:
      "Zadara Cloud supports multiple deployment models, including on-premises, hybrid, multi-cloud, and edge environments, providing flexibility to meet various business requirements.",
  },
  {
    title: "How does Zadara ensure data security and privacy?",
    content:
      "Zadara implements comprehensive security measures, such as data isolation at the controller level, encryption, and adherence to industry compliance standards, ensuring robust data protection.",
  },
  {
    title: "What is the pricing model for Zadara Cloud services?",
    content:
      "Zadara offers a consumption-based pricing model with no long-term contracts and zero data egress fees, allowing organizations to pay only for the resources they use.",
  },
  {
    title: "Can Zadara Cloud integrate with existing IT infrastructures?",
    content:
      "Yes, Zadara's services are designed for seamless integration with existing IT environments, supporting various data types, protocols, and providing compatibility with popular cloud platforms.",
  },
  {
    title: "What kind of support does Zadara provide?",
    content:
      "Zadara offers 24/7 proactive monitoring and support, ensuring continuous assistance and seamless upgrades to maintain optimal performance and reliability.",
  },
  {
    title: "How does Zadara handle multi-tenancy?",
    content:
      "While multiple tenants can operate on the same physical infrastructure, Zadara ensures each tenant experiences predictable performance, full data privacy, and security, effectively providing a single-tenant experience within a multi-tenant environment.",
  },
  {
    title: "What industries benefit from Zadara Cloud services?",
    content:
      "Zadara Cloud caters to various industries, including finance, healthcare, government, manufacturing, media, and telecommunications, offering tailored solutions to meet specific industry requirements.",
  },
  {
    title: "Does Zadara support cloud-native applications?",
    content:
      "Yes, Zadara's zCompute service provides a platform for designing and building cloud-native applications, offering scalability, resilience, and seamless integration with modern cloud environments.",
  },
  {
    title: "What is the Zadara Sovereign AI Edge Cloud?",
    content:
      "The Zadara Sovereign AI Edge Cloud is a solution that provides access to AI resources, including GPU-powered compute, at edge locations worldwide, enabling low-latency and high-performance AI applications.",
  },
];
